import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';

export const SigmaAccount = zod.object({
  accountCode: zod.string(),
  sigmaCompanyId: zod.number(),
  isAlarmAccount: zod.boolean(),
  isAccessControlAccount: zod.boolean(),
});

export const SigmaIntegrationFormSchema = zod
  .object({
    token: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    accounts: zod.array(zod.string()),
  })
  .merge(IntegrationFormSchema);
